import Image from 'next/image'

import { cn } from '~/utils/tailwind-utils'

interface DisplayImageProps {
  imageUrl: string | null | undefined
  alt: string
  size?: number
  className?: string
  shape?: 'rounded' | 'circular'
}

export const DisplayImage: React.FC<DisplayImageProps> = ({
  imageUrl,
  alt,
  size = 72,
  className,
  shape = 'rounded',
}) => {
  const shapeClass = cn(
    'h-full w-full object-cover',
    {
      'rounded-md': shape === 'rounded',
      'rounded-full': shape === 'circular',
    },
    className,
  )

  if (!imageUrl) {
    return <div className={shapeClass} style={{ width: size, height: size }} />
  }

  return (
    <Image
      src={imageUrl}
      alt={alt}
      width={size}
      height={size}
      className={shapeClass}
    />
  )
}
